export const ADDRESS_SEARCH_REQUEST = "ADDRESS_SEARCH_REQUEST";
export const ADDRESS_SEARCH_SUCCESS = "ADDRESS_SEARCH_SUCCESS";
export const ADDRESS_SEARCH_ERROR = "ADDRESS_SEARCH_ERROR";
export const SET_ADDRESS_QUERY = "SET_ADDRESS_QUERY";
export const SELECT_ADDRESS = 'SELECT_ADDRESS';

export const fetchAddresses = (query, location = null) => {
    return {
        type: 'CALL_API',
        types: [ADDRESS_SEARCH_REQUEST, ADDRESS_SEARCH_SUCCESS, ADDRESS_SEARCH_ERROR],
        path: location ? `api/address?lat=${location.latitude}&lng=${location.longitude}&maxDistance=300` : `api/address?q=${query}`,
        payload: {
            query
        }
    };
};

export const setAddressQuery = (query) => {
    return { type: SET_ADDRESS_QUERY, payload: { query } }
};

export const selectAddress = (address) => {
    return { type: SELECT_ADDRESS, payload: { address } }
};



// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/address.js